export const HACFootNote = (): JSX.Element => (
    <p>
      NWAU deductions for Hospital Acquired Complications (HACs) were first implemented in 2018-19, as part of NWAU18. Therefore, the default NWAU version used for 2017-18 data in the HAC dashboard is NWAU18.
    </p>
  )